<template>
<a ref="root" :href="`https://www.youtube.com/embed/${youtubeId}`">
    <slot></slot>
</a>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const $ = window.jQuery;

export default {

    props: {
        youtubeId: {
            type: String,
            required: true
        }
    },
    
    setup(props) {
        const root = ref(null);

        onMounted(() => {
            $(root.value).modaal({
                type: 'video',
                background: '#111111',
                overlay_opacity: 0.92
            });
        });

        onBeforeUnmount(() => {
            $(root.value).off();
        });

        return {
            root
        }

    }

}
</script>